<template>
  <div v-loading="loading" class="chart-box">
    <div class="chart-box-row">
      <div class="chart-box-item">
        <v-chart class="chart-box-control" :options="chartTypeTotal" />
        <div class="total">
          <div class="label">总数量</div>
          <div class="num">{{ totalSum }}个</div>
        </div>
      </div>
      <div class="chart-box-item">
        <v-chart class="chart-box-control" :options="chartType" />
        <div class="total">
          <div class="label">总数量</div>
          <div class="num">{{ totalSum }}个</div>
        </div>
      </div>
    </div>

    <div class="type-list">
      <div class="type-item" :class="{ active: areaType == 'cover_area' }" @click="changeType('cover_area')">
        占地面积
      </div>
      <div class="type-item" :class="{ active: areaType == 'site_area' }" @click="changeType('site_area')">
        硬化场地面积
      </div>
      <div class="type-item" :class="{ active: areaType == 'build_area' }" @click="changeType('build_area')">
        建筑面积
      </div>
    </div>
    <div class="chart-box-row">
      <div class="chart-box-item">
        <v-chart class="chart-box-control" :options="chartAreaTotal" />
        <div class="total">
          <div class="label">总面积</div>
          <div class="num">{{ total }}㎡</div>
        </div>
      </div>
      <div class="chart-box-item">
        <v-chart class="chart-box-control" :options="chartArea" />
        <div class="total">
          <div class="label">总面积</div>
          <div class="num">{{ total }}㎡</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import ECharts from 'vue-echarts';

Vue.component('v-chart', ECharts);
import 'echarts/lib/chart/pie';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/toolbox';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/legendScroll';

export default {
  props: ['form'],
  data() {
    let chart = {
      title: {
        left: 223,
        textAlign: 'center',
      },
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)',
      },
      legend: {
        data: [],
        type: 'scroll',
        orient: 'vertical',
        right: 0,
        top: 30,
      },
      series: {
        type: 'pie',
        left: '7%',
        width: '80%',
        radius: ['50%', '70%'],
        center: ['50%', '50%'],
        data: [],
        label: {
          distanceToLabelLine: 0,
          bleedMargin: '-10%',
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)',
          },
        },
      },
    };
    return {
      areaType: 'cover_area',
      loading: false,
      total: 0,
      totalSum: 0,
      pieData: {},
      chartAreaTotal: {
        title: { text: '宗教及民间信仰场所类型面积统计', ...chart.title },
        tooltip: chart.tooltip,
        legend: {
          ...Object.assign({}, chart.legend),
        },
        series: [Object.assign({ name: '面积' }, chart.series)],
      },
      chartArea: {
        title: { text: '宗教及民间信仰场所区域面积统计', ...chart.title },
        tooltip: chart.tooltip,
        legend: {
          ...Object.assign({}, chart.legend),
          data: [],
        },
        series: [Object.assign({ name: '面积' }, chart.series)],
      },

      chartTypeTotal: {
        title: { text: '宗教及民间信仰场所类型统计', ...chart.title },
        tooltip: chart.tooltip,
        legend: {
          ...Object.assign({}, chart.legend),
        },
        series: [Object.assign({ name: '数量' }, chart.series)],
      },

      chartType: {
        title: { text: '宗教及民间信仰场所区域类型统计', ...chart.title },
        tooltip: chart.tooltip,
        legend: {
          ...Object.assign({}, chart.legend),
        },
        series: [Object.assign({ name: '数量' }, chart.series)],
      },
    };
  },

  methods: {
    //获取折线类型数据
    async getList() {
      this.loading = true;
      try {
        let res = await this.api.basic.analyse(this.form);
        this.pieData = res.data;
        this.chartTypeTotal.series[0].data = this.pieData.typeCountArr;
        this.chartTypeTotal.legend.data = this.pieData.typeCountArr.map((item) => item.name);
        this.chartType.series[0].data = this.pieData.areaCountArr;
        this.chartType.legend.data = this.pieData.areaCountArr.map((item) => item.name);
        this.totalSum = this.pieData.count;
        this.changeType(this.areaType);
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },

    changeType(type) {
      this.areaType = type;
      this.total = this.pieData[type].total;
      this.chartAreaTotal.series[0].data = this.pieData[type].arrSumType;
      this.chartAreaTotal.legend.data = this.pieData[type].arrSumType.map((item) => item.name);
      this.chartArea.series[0].data = this.pieData[type].arrSumArea;
      this.chartArea.legend.data = this.pieData[type].arrSumArea.map((item) => item.name);
    },
  },
};
</script>

<style scoped>
.chart-box {
  margin-top: 30px;
}
.chart-box-row {
  display: flex;
  flex-shrink: 0;
}

.chart-box .chart-box-item {
  flex: 1;
  position: relative;
}

.chart-box .chart-box-control {
  width: 100%;
  height: 400px;
}

.chart-box .total {
  position: absolute;
  left: 50%;
  width: 200px;
  top: 50%;
  transform: translate(-116px, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 17px;
}

.type-list {
  display: flex;
  align-content: center;
  justify-content: center;
  margin-bottom: 30px;
}
.type-list .type-item {
  height: 25px;
  display: flex;
  width: 100px;
  align-items: center;
  justify-content: center;
  border: 1px solid #ccc;
  position: relative;
  color: #666;
  cursor: pointer;
  user-select: none;
}
.type-list .type-item:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  left: 1px;
}
.type-list .type-item:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  left: -1px;
}
.type-list .type-item.active {
  z-index: 1;
  border-color: #409eff;
  color: #409eff;
}
</style>
